export const noDataHint =
  'No Cost Centers have been allocated to your profile thus we\'re not able to display insights or reports. Please contact us to have this rectified.';

// Chart utilisation constants
export const VEHICLE_UTILISATION = 'Vehicle Utilisation';
export const VEHICLE_UTILISATION_GRAPH = 'Vehicle Utilisation Graph';
export const CHART_UTILISATION = 'chartUtilisation';
export const OVER_UTILISED = 'Over utilised';
export const ACCEPTABLE = 'Acceptable';
export const UNDER_UTILISED = 'Under utilised';
export const CHART_SCATTER_PLOT = 'chartScatterPlot';
export const ELAPSED_LEASE_PERCENT = 'Category';
export const KEY_UNDERS = ['key unders','Submitted'];
export const KEY_OVERS = ['key overs','Outstanding'];

export const DRIVER_SAFETY_SUMMARY = 'chartDriverSafetySummary';
export const DRIVER_SAFETY_DETAILED_VIEW = 'chartDriverSafetyDetailedView';

export const CHART_HEAT_MAP = 'chartHeatMap';
export const CHART_HEAT_MAP_SUMMARY = 'chartHeatMapSummary';
export const CHART_SUMMARY_SPLINE = 'chartSummarySpline';
export const CHART_SUMMARY_DISPLAY = 'chartSummaryDisplay';
export const FLEET_COMPOSITION_GRAPH = 'Fleet Composition';

export const DUE_REPORT_REGEX = new RegExp('(\\sdue\\s?)', 'gi');

// Default api to be called
export const DEFAULT_GRAPH_DATA_API = 'insight/getGraphData';



// WEBPACK FOOTER //
// ./src/features/insights/const.js